import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Menu, Dropdown, Icon, Button, Badge, Input } from 'antd';
import { Link } from 'react-router-dom';
import planeIcon from '../../assets/plane-icon.svg';
import dropdownIcon from '../assets/icon-dropdown.svg';
import styles from './AircraftDropdown.module.less';

const AircraftDropdown = ({
  aircraftList,
  selectedAircraft,
  onSearchChange,
  searchValue,
  toggleDrawer,
  menuOnly,
  forMobile,
  intl: { formatMessage },
}) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const searchInput = useRef();
  const getAircraftStatus = (aircraft) => {
    let acStatus = 'error';
    let acStatusText = formatMessage({ id: 'status.unserviceable' });
    if (aircraft && aircraft.maintenance_status) {
      if (aircraft.maintenance_status === 'ok' || aircraft.maintenance_status === 'serviceable') {
        acStatus = 'success';
        acStatusText = formatMessage({ id: 'status.serviceable' });
      } else if (aircraft.maintenance_status === 'critical') {
        acStatus = 'warning';
        acStatusText = formatMessage({ id: 'status.inTolerance' });
      }
    }
    return {
      status: acStatus,
      text: acStatusText,
    };
  };

  const handleVisibleChange = (flag) => {
    if (window.innerWidth > 576) {
      setDropdownVisible(flag);
      if (flag) {
        // Timeout is required to focus input once it was rendered in dropdown
        setTimeout(() => {
          if (searchInput.current) {
            searchInput.current.focus();
          }
        }, 50);
      }
    } else {
      toggleDrawer();
    }
  };

  const handleMenuClick = (e) => {
    if (e.key !== 'search') {
      setDropdownVisible(false);
    }
  };

  const menu = (
    <Menu className={styles.aircraftMenu} onClick={handleMenuClick}>
      <Menu.Item key="search">
        <Input
          prefix={<Icon type="search" />}
          placeholder={formatMessage({ id: 'form.placeholder.searchRegistration' })}
          className={styles.inputSearchReg}
          value={searchValue}
          onChange={onSearchChange}
          ref={searchInput}
        />
      </Menu.Item>
      {aircraftList
        .filter((item) => item.id !== selectedAircraft.id)
        .map((ac) => {
          return (
            <Menu.Item key={ac.id}>
              <Link to={ac.path} className={styles.aircraftLinkSingleWrapper}>
                <span className={styles.aircraftRegistration}>{ac.registration || '-'}</span>
                <span className={styles.aircraftType}>
                  {ac.aircraft_type && ac.aircraft_type.designator ? ac.aircraft_type.designator : '-'}
                </span>
                <span className={styles.aircraftStatus}>
                  <Badge status={getAircraftStatus(ac).status} />{' '}
                  <span className={styles.aircraftStatusText}>{getAircraftStatus(ac).text}</span>
                </span>
              </Link>
            </Menu.Item>
          );
        })}
    </Menu>
  );
  if (menuOnly) {
    return menu;
  }
  return (
    <Dropdown
      overlay={menu}
      trigger={['click']}
      onVisibleChange={handleVisibleChange}
      visible={dropdownVisible}
      overlayStyle={{ position: 'fixed', maxHeight: '78vh', overflowY: 'scroll' }}
    >
      <Button type="link" className={styles.activeAircraftWrapper}>
        <div className={styles.iconWrapper}>
          <img src={planeIcon} alt="planeIcon" />
        </div>
        <div className={styles.acWrapper}>
          <div className={styles.regWrapper}>
            <Badge status={getAircraftStatus(selectedAircraft).status} />
            {selectedAircraft.registration || '-'}
          </div>
          <div className={styles.statusWrapper}>{getAircraftStatus(selectedAircraft).text}</div>
        </div>
        <div className={styles.toggleWrapper}>
          <img src={dropdownIcon} alt="dropdownIcon" />
        </div>
      </Button>
    </Dropdown>
  );
};

AircraftDropdown.propTypes = {
  intl: PropTypes.shape({ formatMessage: PropTypes.func }).isRequired,
  aircraftList: PropTypes.array.isRequired,
  selectedAircraft: PropTypes.object,
  onSearchChange: PropTypes.func.isRequired,
  searchValue: PropTypes.string,
  toggleDrawer: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  forMobile: PropTypes.bool,
  menuOnly: PropTypes.bool,
};

AircraftDropdown.defaultProps = {
  selectedAircraft: {},
  searchValue: null,
  toggleDrawer: false,
  forMobile: false,
  menuOnly: false,
};

export default injectIntl(AircraftDropdown);
